import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  computed,
  inject,
  signal
} from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-global-loading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './global-loading.component.html',
  styleUrl: './global-loading.component.scss'
})
export class GlobalLoadingComponent implements OnInit, OnDestroy {
  readonly loading = inject(LoadingService);

  private readonly messages = [
    'Conectando con servicios...',
    'Consultando informaci\u00F3n...',
    'Cargando configuraci\u00F3n...',
    'Preparando tu espacio...'
  ];

  private messageTimer: ReturnType<typeof setInterval> | null = null;

  readonly messageIndex = signal(0);
  readonly message = computed(() => this.messages[this.messageIndex()]);

  ngOnInit(): void {
    this.messageTimer = setInterval(() => {
      if (this.loading.visible()) {
        this.messageIndex.update(
          index => (index + 1) % this.messages.length
        );
      }
    }, 1500);
  }

  ngOnDestroy(): void {
    if (this.messageTimer !== null) {
      clearInterval(this.messageTimer);
      this.messageTimer = null;
    }
  }
}
